
//
// Fancy Row Highlight
//
// Little bit google, little bit windows taskbar.
//

module.exports = function FancyRowHighlight ($host, config) {

  // Config
  var color = 'rgba(186, 186, 255, 0.05)';

  // Dom
  var $rows = $('tr', $host);

  // Functions
  function gradientAt (pos) {
    var x = Math.round(pos.x) + 'px', y = Math.round(pos.y) + 'px';
    return "radial-gradient(300px at " + x + " " + y + ", " + color + ", transparent)";
  }

  function applyGradient (el, event) {
    var locus = normaliseMouse(el, event);
    el.style.backgroundImage = gradientAt(locus);
  }

  function clearGradient (el) {
    el.style.backgroundImage = 'none';
  }

  function normaliseMouse (el, event) {
    var bb = el.getBoundingClientRect();
    return { x: event.clientX - bb.left, y: event.clientY - bb.top };
  }

  // Listeners (delegate to cope with rearranged/destroyed tables)
  $host.on('mouseenter', 'tr', jqe(applyGradient));
  $host.on('mousemove',  'tr', jqe(applyGradient));
  $host.on('mouseleave', 'tr', jqe(clearGradient));

}

